export function SAVE_LISTS(state, [site_lists]){
    state.country_areas = site_lists.country_areas
    state.faq_categories = site_lists.faq_categories
    state.genders = site_lists.genders
    state.group_users_labels = site_lists.group_users_labels
    state.groups_user = site_lists.groups_user
    state.library_file_categories = site_lists.library_file_categories
    state.trail_complete_categories = site_lists.trail_complete_categories
    state.has_trailcomplete_null_category = site_lists.has_trailcomplete_null_category
    state.library_file_extensions = site_lists.library_file_extensions
    state.marital_status = site_lists.marital_status
    state.reward_categories = site_lists.reward_categories
    state.reward_departments = site_lists.reward_departments
    state.reward_levels = site_lists.reward_levels
    state.tags = site_lists.tags
    state.countries = site_lists.countries
    state.wildcard_pages = site_lists.wildcard_pages
}